import { Component } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { PaisesEditarPage } from '../paises-editar/paises-editar'
import { Storage } from '@ionic/storage'
import { PaisesProvider } from '../../providers/paises/paises'
import { paises } from '../../models/paises'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'

@IonicPage()
@Component({
  selector: 'configuracioncolores',
  templateUrl: 'configuracioncolores.html',
  providers: [ AuthService ]
})
export class ConfiguracioncoloresPage {
  codigoPais: string = ""
  nombrePais: string = ""
  pais: any[] = []

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  colorPrimario: string = '#3880ff';
  colorSecundario: string = '#3dc2ff';
  colorTexto: string = '#000000';
  colorPrimarioR = 255;
colorPrimarioG = 255;
colorPrimarioB = 255;
colorSecundarioR = 255;
colorSecundarioG = 255;
colorSecundarioB = 255;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: PaisesProvider ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService, private storage: Storage
  ) {
    this.cargarColores();
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
        }
      })
    this.cargarServicio()
  }

  ionViewWillEnter() {
    this.cargarServicio()
  }

  ionViewDidLoad() {
    this.cargarServicio()
  }


  guardar() {
    this.guardarServicio()
  }
  editarPais(pais: paises) {
    let modal = this.modalControllers.create(PaisesEditarPage, { pais })
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {

        data.name = "dataDynamicCrud"
        data.paisesId = data.paisesId
        data.queHago = "A"
        data.nombreTabla = "paises"

        this.servicio.actualizar(data)
        .subscribe(
          res => {
            this.pais = []
            this.cargarServicio()
          },
          err => console.log(err)
        )
      }
    })
  }

  editarRegistros(originalTodo: paises, modificadoTodo: paises) {
    const index = this.pais.indexOf(originalTodo);
    this.pais = [
      ...this.pais.slice(0, index),
      modificadoTodo,
      ...this.pais.slice(index + 1)
    ]
    this.pais = []
    this.cargarServicio()
  }

  eliminarPais(todo: any) {
    let paises = []
    paises['queHago'] = "E"
    paises['name'] = "dataDynamicCrud"
    paises['nombreTabla'] = "paises"
    paises['paisesId'] = todo.paisesId
    this.servicio.eliminar(paises)
    .subscribe(
      res => {
        this.pais = []
        this.cargarServicio()
      },
      err => console.log(err)
    )
  }

  guardarServicio() {
    let datosPais: any = {
      codigoPais: this.codigoPais,
      nombrePais: this.nombrePais,
      queHago: "I",
      nombreTabla: "paises",
      name: "dataDynamicCrud"
    }

    this.servicio.guardar(datosPais)
      .subscribe(
      res => this.pais.push(res[0]),
      err => console.log(err)
      )

    this.nombrePais = ""
    this.codigoPais = ""

  }
  cargarServicio() {
    this.servicio.buscar()
      .subscribe((data) => {
        this.pais = data
      }, error => {
        console.log(error)
      })
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  cargarColores() {
    this.storage.get('coloresApp').then((colores) => {
      if (colores) {
        this.colorPrimario = colores.colorPrimario || this.colorPrimario;
        this.colorSecundario = colores.colorSecundario || this.colorSecundario;
        this.colorTexto = colores.colorTexto || this.colorTexto;
      }
    });
  }

  guardarColores() {
    // const colores = {
    //   colorPrimario: this.colorPrimario,
    //   colorSecundario: this.colorSecundario,
    //   colorTexto: this.colorTexto
    // };
    // this.storage.set('coloresApp', colores);
    // this.aplicarColores();
    // this.navCtrl.pop();
    const colorPrimario = `rgb(${this.colorPrimarioR}, ${this.colorPrimarioG}, ${this.colorPrimarioB})`;
    const colorSecundario = `rgb(${this.colorSecundarioR}, ${this.colorSecundarioG}, ${this.colorSecundarioB})`;

    const colores = {
      colorPrimario,
      colorSecundario,
    };

    // Guarda los colores en el almacenamiento local
    this.storage.set('coloresApp', colores);

    // Aplica los colores en tiempo real
    this.aplicarColores(this.colorPrimario, colorSecundario);

    // Navega de vuelta después de guardar
    this.navCtrl.pop();
  }

  // aplicarColores() {
  //   document.documentElement.style.setProperty('--ion-color-primary', this.colorPrimario);
  //   document.documentElement.style.setProperty('--ion-color-secondary', this.colorSecundario);
  //   document.documentElement.style.setProperty('--ion-text-color', this.colorTexto);
  // }
  // aplicarColores(colorPrimario, colorSecundario) {
  //   document.documentElement.style.setProperty('--ion-color-primary', colorPrimario);
  //   document.documentElement.style.setProperty('--ion-color-secondary', colorSecundario);
  // }
  aplicarColores(colorPrimario, colorSecundario) {
    // Cambia los colores de las propiedades CSS de Ionic
    document.documentElement.style.setProperty('--ion-color-primary', colorPrimario);
    document.documentElement.style.setProperty('--ion-color-secondary', colorSecundario);
    localStorage.setItem('colorPrimario', colorPrimario);
  localStorage.setItem('colorSecundario', colorSecundario);
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuracioncolores/configuracioncolores.ts